
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import styles from './workOrderMobile.module.css';
import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from '../../../../components/AddLogs';
import axios from 'axios';
import { useEffect } from 'react';
import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const WorkOrderMobile = ({ isPanelOpen, onToggle, requestData, setRequestData, setLoading }) => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [isReschedule, setIsReschedule] = useState(false);
  const [selectedTime, setSelectedTime] = useState("");
  const [prevScTime, setPrevScTime] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [prevScDate, setPrevScDate] = useState(null);
  const [selectedTechnician, setSelectedTechnician] = useState(0);
  const [prevTechnician, setPrevTechnician] = useState(0);
  const [technicianList, setTechnicianList] = useState([]);

  useEffect(() => {
    async function getAssigneeList() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      axios.get(process.env.REACT_APP_CASE_API_URL + "v1/technicians-new", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setTechnicianList(response.data.data);
      }).catch((error) => { });
    }
    getAssigneeList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (requestData) {
      setPrevTechnician(requestData?.technician_id);
      setSelectedTechnician(requestData?.technician_id);

      if (requestData?.schedule_date) {
        setPrevScDate(dayjs(requestData?.schedule_date));
        setSelectedDate(dayjs(requestData?.schedule_date));
      }
      setPrevScTime(requestData?.schedule_time);
      setSelectedTime(requestData?.schedule_time);
    }
  }, [requestData]);

  const scheduleDateTime = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-schedule/" + requestData?.id, { schedule_date: dayjs(selectedDate).format('YYYY-MM-DD'), schedule_time: selectedTime }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setRequestData(prev => {
        return { ...prev, schedule_date: response.data.data.schedule_date, schedule_time: response.data.data.schedule_time, current_status: 2 };
      });

      if (response.data.data.schedule_date) {
        setPrevScDate(dayjs(response.data.data.schedule_date));
        setSelectedDate(dayjs(response.data.data.schedule_date));
      }
      setPrevScTime(response.data.data.schedule_time);
      setSelectedTime(response.data.data.schedule_time);

      let logData = {
        title: "A maintenant request has been scheduled.",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
          "Technician: " + response.data.data.technician_name,
          "Date/Time: " + dayjs(response.data.data.schedule_date).format('MM/DD/YYYY') + " - " + response.data.data.schedule_time,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const rescheduleDateTime = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-reschedule/" + requestData?.id, { schedule_date: dayjs(selectedDate).format('YYYY-MM-DD'), schedule_time: selectedTime }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setRequestData(prev => {
        return { ...prev, schedule_date: response.data.data.schedule_date, schedule_time: response.data.data.schedule_time, current_status: 2 };
      });

      if (response.data.data.schedule_date) {
        setPrevScDate(dayjs(response.data.data.schedule_date));
        setSelectedDate(dayjs(response.data.data.schedule_date));
      }
      setPrevScTime(response.data.data.schedule_time);
      setSelectedTime(response.data.data.schedule_time);
      setIsReschedule(false);

      let logData = {
        title: "A maintenant request has been scheduled.",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
          "Technician: " + response.data.data.technician_name,
          "Date/Time: " + dayjs(response.data.data.schedule_date).format('MM/DD/YYYY') + " - " + response.data.data.schedule_time,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const assignTechnician = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-assign/" + requestData?.id, { technician_id: selectedTechnician }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setRequestData(prev => {
        return { ...prev, technician_id: response.data.data.technician_id, technician_name: response.data.data.technician_name };
      });

      let logData = {
        title: "A technician has been assigned to request",
        description: [
          "Name: " + response.data.data.title,
          "Request number: " + response.data.data.request_no,
          "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
          "Tenant: " + response.data.data.tenant_name,
          "Technician: " + response.data.data.technician_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const isTimeSlotDisabled = () => {
    if (user["https://propertydek.com/permissions"].indexOf("request-schedule:read") === -1) {
      return true;
    }

    if (requestData?.current_status > 1 && !isReschedule) {
      return true;
    }

    if (parseInt(requestData?.is_tenant_timeslot) === 1) {
      return true;
    }

    return false;
  }

  return (<>
    <div className={`${styles.AccordionList}`}>
      <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("three")}>
        <p className={`${styles.Title}`}>Work Order</p>
        <img src="/static/img/downTriangle.svg" />
      </div>
      <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
        <div className={`${styles.AccouFormGroup}`}>
          <form>
            <div className={`${styles.ReqAddRow}`}>
              <div className={`${styles.ReqAddFormSec}`}>
                <div className={`${styles.FormSec}`}>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <p className={`${styles.FilterLabel}`}>Technician Selection</p>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Select Technician *</InputLabel>
                      <Select
                        label="Select Technician *"
                        value={selectedTechnician ? selectedTechnician : ''}
                        onChange={(e) => { setSelectedTechnician(e.target.value); }}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-assigntechnician:read") > -1) || requestData?.current_status === 3 || requestData?.current_status === 4}
                      >
                        {technicianList?.map(i => {
                          return <MenuItem value={i?.value}>{i?.label}</MenuItem>
                        })}
                      </Select>
                    </FormControl>
                    {(selectedTechnician > 0 && prevTechnician !== selectedTechnician) && <button type='button' className={`${styles.SummaryUpdateBU}`} onClick={(e) => assignTechnician()}>Assign</button>}
                  </div>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <p className={`${styles.FilterLabel}`}>Date & Time Selection</p> 
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Schedule Date *"
                        value={selectedDate}
                        onChange={(e) => { setSelectedDate(e); }}
                        renderInput={(params) => (<TextField {...params} />)}
                        disablePast
                        disabled={requestData?.current_status === 0 || !(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-schedule:read") > -1) || (requestData?.current_status > 1 && !isReschedule)}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className={`${styles.FormGroupFull} FormGroup`}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Select Time *</InputLabel>
                      <Select
                        label="Select Time *"
                        value={selectedTime}
                        onChange={(e) => { setSelectedTime(e.target.value); }}
                        disabled={requestData?.current_status === 0 || isTimeSlotDisabled()}
                      >
                        <MenuItem value={"Morning (9AM - 12PM)"}>Morning (9AM - 12PM)</MenuItem>
                        <MenuItem value={"Afternoon (12PM - 3PM)"}>Afternoon (12PM - 3PM)</MenuItem>
                        <MenuItem value={"Evening (3PM - 6PM)"}>Evening (3PM - 6PM)</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-schedule:read") > -1 && <>
                    {(selectedDate && selectedTime && (dayjs(prevScDate).format('YYYY-MM-DD') !== dayjs(selectedDate).format('YYYY-MM-DD') || prevScTime !== selectedTime)) && <button type='button' className={`${styles.SummaryUpdateBU}`} onClick={(e) => isReschedule ? rescheduleDateTime() : scheduleDateTime()}>Save</button>}
                    {!isReschedule && requestData?.current_status === 2 && <button className={`${styles.AppoResBU}`} onClick={(e) => setIsReschedule(true)}>Reschedule Appointment</button>}
                  </>}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </>)
}

export default WorkOrderMobile;
